import React, {useEffect, useState} from 'react'
import associateServices from "../../services";
import {useSelector} from "react-redux";
import {useParams} from "react-router-dom";
import Loading from "../../components/loading";

const SportsBook = () => {
    const {type} = useParams()
    const [cssTheme, setCssTheme] = useState('')
    const {theme, activeLanguage, agent} = useSelector(state => state.globalReducer)
    const {selectedWallet, authenticated} = useSelector(state => state.authenticationReducer)
    const [sApi, setSApi] = useState(null)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        try {
            if (authenticated) {
                if (activeLanguage?.key && selectedWallet?.code) {
                    const value = {
                        currency: selectedWallet?.code === 'TRY' ? 'TRY' : 'USD',
                        type: 'real',
                        code: selectedWallet?.code,
                        theme,
                        language: activeLanguage?.key,
                        device: agent?.isMobile ? 'mobile' : 'web'
                    }

                    setLoading(true)
                    associateServices.getESportURL(value).then(res => {
                        if (res?.status === 200) {
                            setCssTheme(res?.data?.css)
                            const response = JSON.parse(res?.data?.url)
                            const container = document.getElementById('sports-container')
                            if (container) {
                                container.innerHTML = response?.gameHtml
                                eval(response.gameScript)
                            }
                        }
                        setLoading(false)
                    })
                }
            } else {
                if (activeLanguage?.key) {
                    const value = {
                        currency: 'USD',
                        type: 'demo',
                        theme,
                        language: activeLanguage?.key
                    }

                    setLoading(true)
                    associateServices.getESportURL(value).then(res => {
                        if (res?.status === 200) {
                            setCssTheme(res?.data?.css)
                            const response = JSON.parse(res?.data?.url)
                            const container = document.getElementById('sports-container')

                            if (container) {
                                container.innerHTML = response?.gameHtml
                                eval(response.gameScript)
                            }
                        }
                        setLoading(false)
                    })
                }
            }
        } catch (e) {
            console.log(e)

        }

    }, [selectedWallet?.code, theme, activeLanguage?.key, authenticated])


    const [scriptLoaded, setScriptLoaded] = useState(false);

    useEffect(() => {
        let retries = 0;
        const maxRetries = 3;

        const loadScript = () => {
            return new Promise((resolve, reject) => {
                if (document.getElementById('sportsbook-api-client')) {
                    return resolve(); // Script already exists
                }

                const script = document.createElement('script');
                script.src = 'https://cdn-static.esportings.com/sbapi/v1/sportsbook-api.js';
                script.id = 'sportsbook-api-client';
                script.async = true;

                script.onload = () => resolve();
                script.onerror = () => reject(new Error('Failed to load Sportsbook API script'));

                document.body.appendChild(script);
            });
        };

        const loadApi = async () => {
            try {
                await loadScript();
                setScriptLoaded(true);
                if (window?.SGSportsBook?.SBApi?.createClient) {
                    setSApi(window.SGSportsBook.SBApi.createClient());
                } else {
                    console.error('SGSportsBook API is not available after script load');
                }
            } catch (error) {
                console.error('Error loading script:', error);
                if (retries < maxRetries) {
                    retries += 1;
                    console.log(`Retrying to load script... Attempt ${retries}`);
                    loadApi(); // Retry loading the script
                }
            }
        };

        loadApi();

        // Cleanup the script when the component unmounts
        return () => {
            const script = document.getElementById('sportsbook-api-client');
            if (script) {
                script.remove();
                setScriptLoaded(false);
            }
        };
    }, [setSApi]);


    useEffect(() => {
        const mainElement = document.getElementById('main')
        const headerElement = document.getElementById('header')
        const sidebarElement = document.getElementById('sidebar')
        const footerElement = document.getElementById('footer')
        mainElement?.classList?.add('main--sport')
        headerElement?.classList?.add('header--sport')
        if (!agent?.isMobile)
            sidebarElement?.classList?.add('active')
        footerElement?.classList?.add('footer--sport')
        return () => {
            mainElement?.classList?.remove('main--sport')
            headerElement?.classList?.remove('header--sport')
            if (!agent?.isMobile)
                sidebarElement?.classList?.remove('active')
            footerElement?.classList?.remove('footer--sport')

        }
    }, [])


    // useEffect(() => {
    //     if (sApi && configuration) {
    //         // console.log(configuration[`sp_${theme?.toLowerCase()}`])
    //         sApi.setCustomCSS({
    //             // url: `https://cdn.ebetlab.com/ebetlab/sportsbook/gambi2-${theme}.css`
    //             url: configuration[`sp_${theme?.toLowerCase()}`]
    //         }, (err, params) => console.log('setCustomCSS = ', err, params))
    //     }
    // }, [sApi, theme, configuration])

    useEffect(() => {
        if (sApi && cssTheme) {
            // console.log(configuration[`sp_${theme?.toLowerCase()}`])
            sApi.setCustomCSS({
                // url: `https://cdn.ebetlab.com/ebetlab/sportsbook/gambi2-${theme}.css`
                url: cssTheme
            }, (err, params) => console.log('setCustomCSS = ', err, params))
        }
    }, [sApi, cssTheme, scriptLoaded])

    useEffect(() => {

        if (sApi && type) {

            // var mainContent = document.querySelector('.main__content');
            // mainContent.style.width = '100%';

            console.log('type = ', type)
            if (type === 'live-betting') {
                sApi.openPage({
                    url: `/live/events`
                }, (err, params) => console.log('openPage = ', err, params))
            } else if (type === 'upcoming') {
                sApi.openPage({
                    url: `/calendar/upcoming`
                }, (err, params) => console.log('openPage = ', err, params))
            } else
                sApi.openPage({
                    url: `/sports/${type}`
                }, (err, params) => console.log('openPage = ', err, params))
        }
    }, [sApi, type])


    return (
        <div className="main__frame">
            {
                loading && <Loading/>
            }

            <div id="sports-container">

            </div>
        </div>
    )
}

export default SportsBook
